<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um analista"
              titulo="Analista responsável"
              v-model="objetoFiltro.analistaResponsavel.descricao"
              @index="
                index =>
                  selecionarChave(
                    index,
                    'analistaResponsavel',
                    listaAnalistas,
                    'id'
                  )
              "
              :items="listaAnalistas.map(e => e.nome)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Todas as Unimeds"
              titulo="Unimed Origem"
              v-model="objetoFiltro.unimedOrigem.descricao"
              @index="selecionarUnimed"
              :items="listaUnimedOrigem.map(e => e.textoExibicao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Tipo Atuação"
              titulo="Tipo Atuação"
              v-model="objetoFiltro.tipoAtuacao.descricao"
              @index="
                index => selecionarChave(index, 'tipoAtuacao', listaTipoAtuacao)
              "
              :items="listaTipoAtuacao.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <ValidationProvider
              name="primeiro"
              :rules="{
                regex: /\b(0?[1-9]|[1-2][0-9]|3[0-1])\b/
              }"
              :customMessages="{
                regex: 'Este valor excede a quantidade de dias válidos.'
              }"
              immediate
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                :icone="objetoFiltro.primeiroDiaEnvio ? 'x' : ''"
                ladoIcone="direito"
                clickIcone
                @click-icone="objetoFiltro.primeiroDiaEnvio = ''"
                maxCaracteres="2"
                apenasNumero
                colorPlaceholder="#9E9E9E"
                placeholder="Digite um dia de envio válido"
                titulo="1º Dia de envio"
                v-model="objetoFiltro.primeiroDiaEnvio"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <ValidationProvider
              name="segundo"
              :rules="{
                regex: /\b(0?[1-9]|[1-2][0-9]|3[0-1])\b/
              }"
              :customMessages="{
                regex: 'Este valor excede a quantidade de dias válidos.'
              }"
              immediate
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                :icone="objetoFiltro.segundoDiaEnvio ? 'x' : ''"
                ladoIcone="direito"
                clickIcone
                @click-icone="objetoFiltro.segundoDiaEnvio = ''"
                maxCaracteres="2"
                apenasNumero
                colorPlaceholder="#9E9E9E"
                placeholder="Digite um dia de envio válido"
                titulo="2º Dia de envio"
                v-model="objetoFiltro.segundoDiaEnvio"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
import FiltroMixin from "@/shared/mixin/FiltroMixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  mixins: [FiltroMixin],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    listaUnimedOrigem: {
      type: Array,
      default: () => []
    },
    listaAnalistas: {
      type: Array,
      default: () => []
    },
    limparUnimed: {
      type: Boolean,
      default: false
    },
    listaTipoAtuacao: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      objetoFiltro: {},
      objetoFiltroVazio: {
        analistaResponsavel: {
          chave: "",
          descricao: ""
        },
        unimedOrigem: {
          chave: "",
          descricao: ""
        },
        tipoAtuacao: {
          chave: "",
          descricao: ""
        },
        primeiroDiaEnvio: "",
        segundoDiaEnvio: ""
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },
  methods: {
    selecionarUnimed(index) {
      this.selecionarChave(index, "unimedOrigem", this.listaUnimedOrigem, "id");
      this.$emit("limpar-pesquisa");
    },
    filtrar() {
      const {
        primeiroDiaEnvio,
        segundoDiaEnvio,
        analistaResponsavel,
        unimedOrigem,
        tipoAtuacao
      } = this.objetoFiltro;

      const objetoFiltro = {
        analista: analistaResponsavel.chave,
        unimedOrigem: unimedOrigem.chave,
        diaEnvio1: primeiroDiaEnvio ? parseInt(primeiroDiaEnvio) : "",
        diaEnvio2: segundoDiaEnvio ? parseInt(segundoDiaEnvio) : "",
        tipoAtuacao: tipoAtuacao.chave
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    }
  },
  watch: {
    limparUnimed() {
      if (this.limparUnimed) {
        this.objetoFiltro.unimedOrigem = {
          chave: "",
          descricao: ""
        };
        this.$emit("unimed-limpada");
      }
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>
